import { delay, http, HttpResponse } from 'msw'

let localOffices = [
  {
    "id": "BE10",
    "name": "EPS Belgium BV",
    "contacts": [
      {
        "id": 25,
        "label": "Finance",
        "phoneNumber": "+3215308353",
        "email": "finance.benelux@europoolsystem.com"
      },
      {
        "id": 26,
        "label": "Orders",
        "phoneNumber": "+3215308324",
        "email": "ordersbe@europoolsystem.com"
      },
      {
        "id": 27,
        "label": "Sales",
        "phoneNumber": "+3215308300",
        "email": "sales.benelux@europoolsystem.com"
      },
      {
        "id": 28,
        "label": "Transport",
        "phoneNumber": "+3215308300",
        "email": "planningwest@europpoolsystem.com"
      }
    ]
  },
  {
    "id": "NL10",
    "name": "EPS Netherlands B.V.",
    "contacts": [
      {
        "id": 25,
        "label": "Finance",
        "phoneNumber": "+3215308353",
        "email": "finance.nederland@europoolsystem.com"
      },
      {
        "id": 26,
        "label": "Orders",
        "phoneNumber": "+3215308324",
        "email": "ordersbe@europoolsystem.com"
      },
      {
        "id": 28,
        "label": "Transport",
        "phoneNumber": "+3215308300",
        "email": "planningwest@europpoolsystem.com"
      }
    ]
  }
];

if (typeof window['mocks'] === 'undefined') {
  window['mocks'] = [];
}

window['mocks'].push(
  http.get('api/LocalOffice', async () => {
    await delay(500);
    return HttpResponse.json({ body: localOffices })
  }),
);
window['mocks'].push(
  http.post('api/LocalOffice', async ({request}) => {
    const body: any = request.body;
    // @ts-ignore
    localOffices = localOffices.map(localOffice => {
      // @ts-ignore
      if (localOffice.id === body.id) {
        return body;
      }
      return localOffice;
    });
    if (body.error) {
      await delay(500);
      return HttpResponse.error();
      // return res(ctx.delay(1000), ctx.status(500), ctx.text('Error'))
    }
    await delay(2000);
    return HttpResponse.json({body});
  }),
);
